export default "__VITE_ASSET__DvVGhCrA__"